import type {DaoMedia} from "../../daos/dao-media.ts";
import {useEffect, useState} from "react";
import {Utils} from "../../modules/utils.ts";
import * as React from "react";
import _ from "lodash";
import {askConfirm} from "../../stores/dialog.thunk.ts";
import {useAppDispatch} from "../../stores/hook.ts";
import {app, onair} from "../../modules/config.ts";
import {OnairEvent} from "../../modules/onair.ts";

interface AnnounceProps {
  announce: DaoMedia,
  listenCallback?: (announce: DaoMedia) => void;
}

export function Announce({announce, listenCallback}: AnnounceProps) {
  const [daoAnnounce] = useState<DaoMedia>(announce);
  const [position, setPosition] = useState<number>(0);
  const dispatch = useAppDispatch();

  useEffect(() => {
    onair.on(OnairEvent.MEDIA, onMediaChangeHandler);
    if(daoAnnounce && onair.media && _.isEqual(String(daoAnnounce.type), String(onair.media.type)) && _.isEqual(String(daoAnnounce.media), String(onair.media.media))) {
      onair.on(OnairEvent.DURATION, onMediaDurationChangeHandler);
    }
    return () => {
      onair.off(OnairEvent.MEDIA, onMediaChangeHandler);
      onair.off(OnairEvent.DURATION, onMediaDurationChangeHandler);
    };
  }, []);

  function onMediaChangeHandler(_media: unknown) {
    const media: DaoMedia = _media as DaoMedia;
    if(media) {
      setPosition(0);
      if(announce && _.isEqual(String(announce.type), String(media.type)) && _.isEqual(String(announce.media), String(media.media))) {
        onair.on(OnairEvent.DURATION, onMediaDurationChangeHandler);
      } else {
        onair.off(OnairEvent.DURATION, onMediaDurationChangeHandler);
      }
    }
  }

  function onMediaDurationChangeHandler(_currentTime: unknown) {
    setPosition(_currentTime as number);
  }

  async function listenHandler(e: React.MouseEvent | React.TouchEvent) {
    e.stopPropagation();
    if(_.isFunction(listenCallback)) {
      const isConfirmed = await dispatch(askConfirm('', `"${daoAnnounce.title}" 안내방송을 재생하시겠습니까?`));
      if (isConfirmed) {
        listenCallback.call(null, daoAnnounce);
      }
    }
  }

  return (
    <article className={`announce-item ${daoAnnounce.type !== 'AD' ? 'schedule' : ''}`}>
      { daoAnnounce.type !== 'AD' && (
        <div className="announce-time">
          <span className="icon"><img alt="" src={`${app.imagePath}/icon-time.png`}/></span>
        </div>
      )}

      <div className="audio-item">
        { daoAnnounce.type !== 'AD' && (
          <div className="audio-header">
            <div className="time"><span>{daoAnnounce.start.substring(0, 5)}</span>{daoAnnounce.start.substring(5, 8)}</div>
          </div>
        )}
        <div className="audio-title">{daoAnnounce.title}</div>
        <div className="audio-bar">
          <div className="audio-bar-fill" style={{ width: `${Math.max(Math.min((((position ?? 0) / (daoAnnounce?.duration ?? 0)) * 100), 100), 0)}%` }}></div>
          <span className="duration">{Utils.duration(daoAnnounce.duration)}</span>
          <button className="play-button" aria-label="재생" onClick={listenHandler}><img alt="" src="/images/icon-play.png"/></button>
        </div>
      </div>
    </article>
  );
}